import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import futureSchool1 from '../../assets/future1.png';
import futureSchool2 from '../../assets/future2.png';
import futureSchool3 from '../../assets/future3.png';
import futureSchool4 from '../../assets/future4.png';
import futureSchool5 from '../../assets/future5.png';
import futureSchool6 from '../../assets/future6.png';
import futureSchool7 from '../../assets/future7.png';
import futureSchool8 from '../../assets/future8.png';

// Add this if you need to use styled-components
// If not using styled-components, you can remove this and use regular CSS classes
const FutureSchoolContainer = styled.section`
  padding: 4rem 2rem;
  background-color: #f8f9fa;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
  font-weight: 700;
`;

const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
  max-width: 1400px;
  margin: 0 auto;
`;

const ImageCard = styled(motion.div)`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 250px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

// Animation variants
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const FutureSchool: React.FC = () => {
  // Replace these with your actual image imports
  const futureImages = [
    { id: 1, src: futureSchool1, alt: 'Future School Vision 1' },
    { id: 2, src: futureSchool2, alt: 'Future School Vision 2' },
    { id: 3, src: futureSchool3, alt: 'Future School Vision 3' },
    { id: 4, src: futureSchool4, alt: 'Future School Vision 4' },
    { id: 5, src: futureSchool5, alt: 'Future School Vision 5' },
    { id: 6, src: futureSchool6, alt: 'Future School Vision 6' },
    { id: 7, src: futureSchool7, alt: 'Future School Vision 7' },
    { id: 8, src: futureSchool8, alt: 'Future School Vision 8' },
  ];

  return (
    <FutureSchoolContainer>
      <Title>Our Vision for the Future</Title>
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        <Gallery>
          {futureImages.map((image) => (
            <ImageCard
              key={image.id}
              variants={item}
              whileHover={{ scale: 1.03 }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
            </ImageCard>
          ))}
        </Gallery>
      </motion.div>
    </FutureSchoolContainer>
  );
};

export default FutureSchool;